import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-abyss" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-2 border-aqua/30 border-t-aqua animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-abyss" data-testid="admin-loading">
        <div className="h-10 w-10 rounded-full border-2 border-aqua/30 border-t-aqua animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  if (user.role !== "admin") return <Navigate to="/tableau-de-bord" replace />;
  return children;
}
